/**
 * pendientes.ts — Web data-layer for the admin "pending work" summary (R50).
 * Admin-only endpoint (403 if the caller is not admin).
 */

import { apiGet } from '@/lib/apiClient';
import { PendientesResumenSchema, type PendientesResumen } from '@siiv/schemas';

/**
 * GET /admin/pendientes/resumen — admin only: per-category pending counts
 * ({ solicitudes, alertas, total }). Backs the module badges + sidebar total.
 */
export async function getPendientesResumen(): Promise<PendientesResumen> {
	const json = await apiGet<unknown>('/admin/pendientes/resumen');
	return PendientesResumenSchema.parse(json);
}
